/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Intro_DescInputs */

const en_ui_onboarding_intro_desc = /** @type {(inputs: Ui_Onboarding_Intro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault analyzes your sessions locally in this browser — no account needed.`)
};

const de_ui_onboarding_intro_desc = /** @type {(inputs: Ui_Onboarding_Intro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PaceVault analysiert deine Einheiten lokal in diesem Browser – ohne Konto.`)
};

/**
* | output |
* | --- |
* | "PaceVault analyzes your sessions locally in this browser — no account needed." |
*
* @param {Ui_Onboarding_Intro_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_intro_desc = /** @type {((inputs?: Ui_Onboarding_Intro_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Intro_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_intro_desc(inputs)
	return de_ui_onboarding_intro_desc(inputs)
});